import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import yn from 'yn'

const CashBack = ({ price, hideIcon, hasCashBack, currency, ruleCashBack, showInstallments, isOnlyCash, showDefaultMultiplier }) => {
  let convertedValue = ruleCashBack === '1' ? Math.floor(0.05 * price) : Math.round(price)
  if (process.env.REACT_APP_CASHBACK_MULTIPLIER && !yn(showDefaultMultiplier)) {
    convertedValue = Math.round(process.env.REACT_APP_CASHBACK_MULTIPLIER * price)
  }
  return (
    <Fragment>
      {hasCashBack && isOnlyCash && (
        <div className='card-price-cashback col-12 txt-body-sm txt-font-body txt-left txt-bold color-success py-half'>
          <div className='row'>
            <div className='col-auto txt-body-sm'>
              {showInstallments
                ? (
                  <Fragment>
                    <span aria-hidden='true'>e você recebe {convertedValue} {currency.name || 'pontos'} de volta</span>
                    <span className='hide-absolute'>{`e você recebe ${convertedValue} ${currency.name || 'pontos'} de volta`}</span>
                  </Fragment>
                ) : (
                  <Fragment>
                    <span aria-hidden='true'>Ganhe {convertedValue} {currency.name || 'pontos'}</span>
                    <span className='hide-absolute'>{`Ganhe ${convertedValue}`}</span>
                  </Fragment>
                )}
            </div>
          </div>
          <div className='border-bottom-dashed border-color-ui-2 mb-2 mt-2' />
        </div>
      )}
    </Fragment>
  )
}

CashBack.propTypes = {
  price: PropTypes.number,
  hideIcon: PropTypes.bool,
  hasCashBack: PropTypes.bool,
  ruleCashBack: PropTypes.string,
  currency: PropTypes.shape({
    decimalPlaces: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  }).isRequired,
  showInstallments: PropTypes.bool,
  isOnlyCash: PropTypes.bool,
  showDefaultMultiplier: PropTypes.bool
}

const mapStateToProps = ({ onlyCash: isOnlyCash }) => {
  return ({
    isOnlyCash
  })
}

export default connect(mapStateToProps)(CashBack)



// WEBPACK FOOTER //
// ./src/Catalog/Availability/PriceLabel/CashBack.js